export default __webpack_public_path__ + "static/media/Landing-Deforestation.b2b11216.jpg";